<po-page-default p-title="Consulta cadastro do cliente">
  <div class="po-m-2" style="text-align: right;">
    <po-button class="po-m-1" p-label="Voltar" (p-click)="cancel()"></po-button>
  </div>
  <po-dynamic-view
    [p-fields]="fields"
    [p-value]="employee"
  >
  </po-dynamic-view>
</po-page-default>
